import request from "../Config/axios";
// -----------------------------------------------------------
export const Add_AdditionalFile_Api = async (params) => {

    const { data } = await request.postMultiPart(
        `/AdditionalFile/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_AdditionalFile_Api = async (reserveId) => {
    const { data } = await request.get(
        `/AdditionalFile/GetAll/?reserveId=${reserveId}`
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_AdditionalFile_Api = async (id) => {
    const { data } = await request.delete(
        `/AdditionalFile/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
